import React from 'react';
import { ArrowRightIcon, CheckIcon, StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
type OfferCardProps = {
  highlighted?: boolean;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  url: string;
  cta: string;
};
export function OfferCard({
  highlighted = false,
  title,
  description,
  originalPrice,
  price,
  url,
  cta
}: OfferCardProps) {
  return <motion.article whileHover={{
    y: -4
  }} transition={{
    duration: 0.2
  }} className={`relative flex h-full flex-col rounded-2xl border p-6 sm:p-8 ${highlighted ? 'border-[#9d3659] bg-[#3a1227] text-[#fff9f2] shadow-[0_20px_60px_rgba(55,12,35,0.32)]' : 'border-[#dcc7bd] bg-[#fff9f2] text-[#301420]'}`} data-id="element-11">
      {highlighted && <div className="absolute -top-3 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-[#d6a25d] px-4 py-1 text-[11px] font-extrabold tracking-wider text-[#381421]" data-id="element-12">
          <StarIcon className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-13" />
          MÁS ELEGIDO
        </div>}
      <p className={`text-xs font-extrabold uppercase tracking-[0.16em] ${highlighted ? 'text-[#e6c48c]' : 'text-[#9d3659]'}`} data-id="element-14">
        {highlighted ? 'Oferta completa' : 'Acceso esencial'}
      </p>
      <h3 className="mt-3 font-serif text-3xl leading-tight" data-id="element-15">{title}</h3>
      <p className={`mt-3 min-h-12 text-sm leading-relaxed ${highlighted ? 'text-rose-100/80' : 'text-[#6d4a55]'}`} data-id="element-16">
        {description}
      </p>
      <div className="mt-7 flex items-end gap-3" data-id="element-17">
        <span className={`mb-1 text-base line-through ${highlighted ? 'text-rose-200/70' : 'text-[#937780]'}`} data-id="element-18">
          {originalPrice}
        </span>
        <span className="font-serif text-5xl leading-none" data-id="element-19">{price}</span>
      </div>
      <p className={`mt-2 text-xs ${highlighted ? 'text-rose-100/70' : 'text-[#80626c]'}`} data-id="element-20">
        Pago único · acceso inmediato
      </p>
      <ul className={`mt-6 space-y-2 border-t pt-5 text-sm ${highlighted ? 'border-rose-200/20 text-rose-50' : 'border-[#eadcd5] text-[#54303d]'}`} data-id="element-21">
        <li className="flex gap-2" data-id="element-22">
          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#d6a25d]" aria-hidden="true" data-id="element-23" />
          6 tomos + 6 bonos
        </li>
        {highlighted && <li className="flex gap-2" data-id="element-24">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#d6a25d]" aria-hidden="true" data-id="element-25" />
            Diario Guiado de 90 días
          </li>}
        <li className="flex gap-2" data-id="element-26">
          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#d6a25d]" aria-hidden="true" data-id="element-27" />
          Garantía de 7 días
        </li>
      </ul>
      <a className={`mt-7 inline-flex min-h-12 items-center justify-center gap-2 rounded-lg px-4 text-center text-sm font-extrabold uppercase tracking-wide transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${highlighted ? 'bg-[#d6a25d] text-[#33121f] hover:bg-[#ecc781] focus-visible:outline-[#fff9f2]' : 'bg-[#7b2948] text-white hover:bg-[#5c1c35] focus-visible:outline-[#7b2948]'}`} href={url} target="_blank" rel="noreferrer" data-id="element-28">
        {cta} <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" />
      </a>
    </motion.article>;
}